import { IconButton } from "react-native-paper";

export default IconButton;